import { render } from "./HomeFeaturedLink.vue?vue&type=template&id=67171d11&scoped=true"
import script from "./HomeFeaturedLink.vue?vue&type=script&lang=js"
export * from "./HomeFeaturedLink.vue?vue&type=script&lang=js"

import "./HomeFeaturedLink.vue?vue&type=style&index=0&id=67171d11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67171d11"]])

export default __exports__